import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/complete-registration.css";
import bg from "/ai3-home-bg1.webp";

export default function CompleteRegistration() {
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName]   = useState("");
  const [password, setPassword]   = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState("");
  const [strength, setStrength]   = useState("");

  const navigate   = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const t = new URLSearchParams(search).get("token");
    if (!t) {
      setError("Token não fornecido.");
      return;
    }
    setToken(t);

    (async () => {
      try {
        const res = await fetch(
          `${import.meta.env.VITE_BACKEND_URL}/api/auth/verify-token?token=${t}`
        );
        const txt = await res.text();
        let data;
        try { data = JSON.parse(txt); } catch { data = {}; }
        if (!res.ok) throw new Error(data?.error || "Token inválido ou expirado.");
        if (data?.email) setEmail(data.email);
      } catch (e) {
        setError(e.message || "Falha ao validar token.");
      }
    })();
  }, [search]);

  useEffect(() => {
    const rules = [/.{8,}/, /[A-Z]/, /[a-z]/, /[0-9]/, /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/];
    const passed = rules.filter((r) => r.test(password)).length;
    setStrength(passed <= 2 ? "Fraca" : passed <= 4 ? "Média" : "Forte");
  }, [password]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!token) return setError("Token ausente.");
    if (!firstName.trim() || !lastName.trim()) return setError("Nome e sobrenome são obrigatórios.");
    if (password !== confirmPassword) return setError("As senhas não coincidem.");

    setLoading(true);
    try {
      const res = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/api/auth/complete-registration`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, email, firstName, lastName, password }),
        }
      );

      const txt = await res.text();
      let payload;
      try { payload = JSON.parse(txt); } catch { payload = { error: txt }; }

      if (!res.ok) throw new Error(payload?.error || "Erro ao concluir cadastro.");

      if (payload?.token) {
        localStorage.setItem("token",     payload.token);
        localStorage.setItem("authToken", payload.token);
        localStorage.setItem("jwt",       payload.token);
        try {
          const axios = (await import("axios")).default;
          axios.defaults.headers.common["Authorization"] = `Bearer ${payload.token}`;
        } catch {}
        // Se quiser, exiba uma tela de sucesso antes; aqui vou direto pro painel
        window.location.replace("/"); // força reload da app lendo o token
      } else {
        throw new Error("Token de sessão não recebido do servidor.");
      }
    } catch (e) {
      setError(e.message || "Erro ao concluir cadastro.");
    } finally {
      setLoading(false);
    }
  }

  const bgStyle = {
    background: `url(${bg}) center/cover`,
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div style={bgStyle}>
      <form className="register-form" onSubmit={handleSubmit}>
        <img src="/logo_viadrive.svg" alt="Logo" className="logo-register" />
        <h2>Finalize seu Cadastro</h2>

        {error && <div className="error-message">{error}</div>}

        <input type="email" value={email} readOnly disabled />

        <div className="name-row">
          <input
            type="text"
            placeholder="Nome"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
            disabled={loading}
          />
          <input
            type="text"
            placeholder="Sobrenome"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div className="password-row">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
          <span onClick={() => setShowPassword((v) => !v)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {password && (
          <div className={`strength ${strength.toLowerCase()}`}>Senha {strength}</div>
        )}

        <input
          type={showPassword ? "text" : "password"}
          placeholder="Confirmar Senha"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          disabled={loading}
        />

        <button type="submit" disabled={loading}>
          {loading ? "Concluindo..." : "Concluir Cadastro"}
        </button>

        <ul className="password-rules">
          <li>Mínimo de 8 caracteres</li>
          <li>Uma letra maiúscula</li>
          <li>Uma letra minúscula</li>
          <li>Um número</li>
          <li>Um caractere especial</li>
        </ul>
      </form>
    </div>
  );
}
